export default __webpack_public_path__ + "static/media/nft-fallback.6b15ffe9.png";